export const alert = (state = null, action) => {
    switch (action.type) {
        case 'ALERT':
            return action.alert;
        default:
            return state
    }
};
